import { AccredibleButtonComponentModule } from '@accredible-frontend-v2/new-components/button';
import { AccredibleCheckboxInputComponentModule } from '@accredible-frontend-v2/new-components/checkbox-input';
import {
  AccredibleConfirmDialogComponentModule,
  AccredibleDialogTemplateComponentModule,
} from '@accredible-frontend-v2/new-components/dialog';
import { AccredibleLinkComponentModule } from '@accredible-frontend-v2/new-components/link';
import { AccredibleToastService } from '@accredible-frontend-v2/new-components/toast';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { DialogRef } from '@angular/cdk/dialog';
import { NgOptimizedImage } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { finalize } from 'rxjs';
import { RequestStatus } from '../../../entities/campaign-sms.model';
import { SmsApiService } from '../../../infrastructure/sms/sms.service';

interface RequestSmsAccessForm {
  consent_sms: FormControl<boolean>;
  sms_limitation: FormControl<boolean>;
}

const TRANSLATION_KEY = 'request-sms-access-dialog';

@Component({
  standalone: true,
  imports: [
    ReactiveFormsModule,
    AccredibleConfirmDialogComponentModule,
    AccredibleDialogTemplateComponentModule,
    AccredibleLinkComponentModule,
    AccredibleCheckboxInputComponentModule,
    AccredibleButtonComponentModule,
    NgOptimizedImage,
    TranslocoModule,
  ],
  templateUrl: 'request-sms-access-dialog.component.html',
  styleUrls: ['request-sms-access-dialog.component.scss'],
})
export class RequestSmsAccessDialogComponent {
  private readonly _dialogRef = inject(DialogRef);
  private readonly _smsApi = inject(SmsApiService);
  private readonly _toast = inject(AccredibleToastService);
  private readonly _language = inject(AccredibleLanguageService);

  formGroup = new FormGroup<RequestSmsAccessForm>({
    consent_sms: new FormControl(false, Validators.requiredTrue),
    sms_limitation: new FormControl(false, Validators.requiredTrue),
  });

  loading = signal(false);

  close(data?: RequestStatus): void {
    this._dialogRef.close(data);
  }

  submit(): void {
    this.loading.set(true);
    this._smsApi
      .requestSmsAccess()
      .pipe(finalize(() => this.loading.set(false)))
      .subscribe({
        next: ({ status }) => {
          this.close(status || 'initial');
          this._toast.success(
            this._language.translate(`${TRANSLATION_KEY}.request_access_success`),
          );
        },
        error: () => {
          this._toast.error(this._language.translate(`${TRANSLATION_KEY}.request_access_error`));
        },
      });
  }
}
